<svg
	width="24px"
	height="24px"
	viewBox="0 0 24 24"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
>
	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<path
			d="M13.05,12 L17.8,7.24999998 C18.1,6.94999998 18.1,6.49999998 17.8,6.19999998 C17.5,5.89999997 17.05,5.89999997 16.75,6.19999998 L12,10.95 L7.24999998,6.19999998 C6.94999998,5.89999997 6.49999998,5.89999997 6.19999998,6.19999998 C5.89999997,6.49999998 5.89999997,6.94999998 6.19999998,7.24999998 L10.95,12 L6.19999998,16.75 C5.89999997,17.05 5.89999997,17.5 6.19999998,17.8 C6.49999998,18.1 6.94999998,18.1 7.24999998,17.8 L12,13.05 L16.75,17.8 C17.05,18.1 17.5,18.1 17.8,17.8 C18.1,17.5 18.1,17.05 17.8,16.75 L13.05,12 Z"
			fill="currentColor"
		></path>
	</g>
</svg>
